<template>
    <div v-if="confirmType == 0 && disablePurchasingOption" style="padding:20px">
        <!--- purchase new license without option ---->
        <table width="100%">
            <tr class="license-record-header">
                <td class="license-item-title" style="width: 30%" v-t="'message.item_license_basic'">
                </td>
                <td class="license-item-title" style="text-align:right;width: 30%" v-t="'message.item_purchase_count'">
                </td>
                <td colspan="2" class="license-item-title" style="text-align: right;padding-right:10px" v-t="'message.item_amount'">
                </td>
            <tr>
            <tr class="license-record-no-hover-bottom">
                <td class="license-item-value">
                    {{ licenseInfo.numberLicense[0].displayName}}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ licenseInfo.numberLicense[0].newValue }}
                </td>
                <td v-if="purchasePeriodType == 0" colspan="2" class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                    {{ getDisplayAmountValue(licenseInfo.numberLicense[0].purchaseMonthlyAmount) }}
                </td>
                <td v-else  colspan="2" class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                    {{ getDisplayAmountValue(licenseInfo.numberLicense[0].purchaseYearlyAmount) }}
                </td>
            </tr>
        </table>
    </div>
    <div v-else-if="confirmType == 1 && disablePurchasingOption" style="padding:20px">
        <!--- change the count of license without option ---->
        <table width="100%">
            <tr class="license-record-header">
                <td class="license-item-title" v-t="'message.item_license_basic'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.item_current_purchase_count'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:25px" v-t="'message.item_changed_purchase_count'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_purchase_current_amount'"></span>
                    <span v-else v-t="'message.item_purchase_next_amount'"></span>
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_purchase_next_amount'"></span>
                    <span v-else v-t="'message.item_purchase_additional_amount'"></span>
                </td>
            <tr>
            <tr class="license-record-no-hover-bottom">
                <td class="license-item-value">
                    {{ licenseInfo.numberLicense[0].displayName}}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ licenseInfo.numberLicense[0].pastMax }}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ licenseInfo.numberLicense[0].newValue }}
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 10px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(licenseInfo.numberLicense[0].newCurrentAmount) }}</span>
                    <span v-else>{{ getDisplayAmountValue(licenseInfo.numberLicense[0].newAmount) }}</span>
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 20px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(licenseInfo.numberLicense[0].newAmount) }}</span>
                    <span v-else>{{ getDisplayAmountValue(licenseInfo.numberLicense[0].purchaseAmount) }}</span>
                </td>
            </tr>
        </table>
    </div>
    <div v-else-if="disablePurchasingOption" style="padding:20px">
        <!--- change purchase period type without option ---->
        <table width="100%">
            <tr class="license-record-header">
                <td class="license-item-title" v-t="'message.item_license_basic'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.title_purchased_number_of_licenses'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.title_renewal_number_of_licenses'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_amount_monthly'"></span>
                    <span v-else v-t="'message.item_amount_yearly'"></span>
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_amount_yearly'"></span>
                    <span v-else v-t="'message.item_amount_monthly'"></span>
                </td>
            <tr>
            <tr class="license-record-no-hover-bottom">
                <td class="license-item-value">
                    {{ licenseInfo.numberLicense[0].displayName}}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ licenseInfo.numberLicense[0].pastMax }}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ licenseInfo.numberLicense[0].orgValue }}
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 10px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(licenseInfo.numberLicense[0].currentAmount) }}</span>
                    <span v-else>{{ getDisplayAmountValue(licenseInfo.numberLicense[0].currentAmount) }}</span>
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 20px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(licenseInfo.numberLicense[0].newAmount) }}</span>
                    <span v-else>{{ getDisplayAmountValue(licenseInfo.numberLicense[0].newAmount) }}</span>
                </td>
            </tr>
        </table>
    </div>
    <div v-else-if="confirmType == 0" style="padding:20px">
        <!--- purchase new license with option ---->
        <table width="100%">
            <tr class="license-record-header">
                <td class="license-item-title" style="width: 30%" v-t="'message.item_license_basic'">
                </td>
                <td class="license-item-title" style="text-align:right;width: 30%" v-t="'message.item_purchase_count'">
                </td>
                <td colspan="2" class="license-item-title" style="text-align: right;padding-right:10px" v-t="'message.item_amount'">
                </td>
            <tr>
            <tr v-for="(license , index) in licenseInfo.numberLicense" :class="{'license-record-no-hover': (index<licenseInfo.numberLicense.length-1),'license-record-no-hover-bottom': (index==licenseInfo.numberLicense.length-1)}">
                <td class="license-item-value">
                    {{ license.displayName}}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ license.newValue }}
                </td>
                <td v-if="purchasePeriodType == 0" colspan="2" class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                    {{ getDisplayAmountValue(license.purchaseMonthlyAmount) }}
                </td>
                <td v-else  colspan="2" class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                    {{ getDisplayAmountValue(license.purchaseYearlyAmount) }}
                </td>
            </tr>
            <hr class="transparent-hr">
            <tr class="license-record-header">
                <td class="license-item-title" style="width: 30%" v-t="'message.item_license_recurring'">
                </td>
                <td class="license-item-title" style="text-align:right;width: 15%;padding-right:25px" v-t="'message.item_purchase_count'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px" v-t="'message.item_amount'">
                </td>
            <tr>
            <tr v-for="(license , index) in licenseInfo.usageLicense" :class="{'license-record-no-hover': (index<licenseInfo.usageLicense.length-1),'license-record-no-hover-bottom': (index==licenseInfo.usageLicense.length-1)}">
                <td class="license-item-value">
                    {{ license.displayName}}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ license.newCount }} ({{ license.newValue.toLocaleString() + getUnitName(license.type) }})
                </td>
                <td v-if="purchasePeriodType == 0" class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                    {{ getDisplayAmountValue(license.purchaseMonthlyAmount) }}
                </td>
                <td v-else class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                    {{ getDisplayAmountValue(license.purchaseYearlyAmount) }}
                </td>
            </tr>
        </table>
    </div>
    <div v-else-if="confirmType == 1" style="padding:20px">
        <!--- change the count of license with option ---->
        <table width="100%">
            <tr class="license-record-header">
                <td class="license-item-title" v-t="'message.item_license_basic'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.item_current_purchase_count'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:25px" v-t="'message.item_changed_purchase_count'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_purchase_current_amount'"></span>
                    <span v-else v-t="'message.item_purchase_next_amount'"></span>
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_purchase_next_amount'"></span>
                    <span v-else v-t="'message.item_purchase_additional_amount'"></span>
                </td>
            <tr>
            <tr v-for="(license , index) in licenseInfo.numberLicense" :class="{'license-record-no-hover': (index<licenseInfo.numberLicense.length-1),'license-record-no-hover-bottom': (index==licenseInfo.numberLicense.length-1)}">
                <td class="license-item-value">
                    {{ license.displayName}}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ license.pastMax }}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ license.newValue }}
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 10px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(license.newCurrentAmount) }}</span>
                    <span v-else>{{ getDisplayAmountValue(license.newAmount) }}</span>
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 20px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(license.newAmount) }}</span>
                    <span v-else>{{ getDisplayAmountValue(license.purchaseAmount) }}</span>
                </td>
            </tr>
            <hr class="transparent-hr">
            <tr class="license-record-header">
                <td class="license-item-title" v-t="'message.item_license_recurring'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.item_current_purchase_count'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.item_purchase_next_change'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_purchase_current_amount'"></span>
                    <span v-else v-t="'message.item_purchase_next_amount'"></span>
                </td>
                <td class="license-item-title" style="text-align: right;padding-right: 20px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_purchase_next_amount'"></span>
                    <span v-else v-t="'message.item_purchase_additional_amount'"></span>
                </td>
            <tr>
            <tr v-for="(license , index) in licenseInfo.usageLicense" :class="{'license-record-no-hover': (index<licenseInfo.usageLicense.length-1),'license-record-no-hover-bottom': (index==licenseInfo.usageLicense.length-1)}">
                <td class="license-item-value">
                    {{ license.displayName}}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ license.current/license.unit }}({{ license.current.toLocaleString() + getUnitName(license.type) }})
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ license.newValue/license.unit }}({{ license.newValue.toLocaleString() + getUnitName(license.type)}})
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 10px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(license.currentAmount) }}</span>
                    <span v-else>{{ getDisplayAmountValue(license.newAmount) }}</span>
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 20px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(license.newAmount) }}</span>
                    <span v-else>-</span>
                </td>
            </tr>
            <hr class="transparent-hr">
            <tr class="license-record-header">
                <td class="license-item-title" v-t="'message.item_license_charge'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.item_current_purchase_count'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.item_add_purchase_count'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_purchase_current_amount'"></span>
                    <span v-else v-t="'message.item_purchase_next_amount'"></span>
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:20px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_purchase_next_amount'"></span>
                    <span v-else v-t="'message.item_purchase_additional_amount'"></span>
                </td>
            <tr>
            <tr v-for="(license , index) in licenseInfo.chargedLicense" :class="{'license-record-no-hover': (index<licenseInfo.chargedLicense.length-1),'license-record-no-hover-bottom': (index==licenseInfo.chargedLicense.length-1)}">
                <td class="license-item-value">
                    {{ license.displayName}}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ license.orgValue/license.unit }}({{ license.orgValue.toLocaleString() + getUnitName(license.type) }})
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ license.newValue/license.unit }}({{ license.newValue.toLocaleString() + getUnitName(license.type)}})
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 10px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(license.newCurrentAmount) }}</span>
                    <span v-else>-</span>
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 20px">
                    <span v-if="purchasePeriodType == 0">-</span>
                    <span v-else>{{ getDisplayAmountValue(license.purchaseAmount) }}</span>
                </td>
            </tr>
        </table>
    </div>
    <div v-else style="padding:20px">
        <!--- change purchase period type with option ---->
        <table width="100%">
            <tr class="license-record-header">
                <td class="license-item-title" v-t="'message.item_license_basic'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.title_purchased_number_of_licenses'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.title_renewal_number_of_licenses'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_amount_monthly'"></span>
                    <span v-else v-t="'message.item_amount_yearly'"></span>
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_amount_yearly'"></span>
                    <span v-else v-t="'message.item_amount_monthly'"></span>
                </td>
            <tr>
            <tr v-for="(license , index) in licenseInfo.numberLicense" :class="{'license-record-no-hover': (index<licenseInfo.numberLicense.length-1),'license-record-no-hover-bottom': (index==licenseInfo.numberLicense.length-1)}">
                <td class="license-item-value">
                    {{ license.displayName}}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ license.pastMax }}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ license.orgValue }}
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 10px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(license.currentAmount) }}</span>
                    <span v-else>{{ getDisplayAmountValue(license.currentAmount) }}</span>
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 20px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(license.newAmount) }}</span>
                    <span v-else>{{ getDisplayAmountValue(license.newAmount) }}</span>
                </td>
            </tr>
            <hr v-if="licenseInfo.usageLicense.length > 0" class="transparent-hr">
            <tr v-if="licenseInfo.usageLicense.length > 0" class="license-record-header">
                <td class="license-item-title" v-t="'message.item_license_recurring'">
                </td>
                <td colspan="2" class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.title_renewal_number_of_licenses'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_amount_monthly'"></span>
                    <span v-else v-t="'message.item_amount_yearly'"></span>
                </td>
                <td class="license-item-title" style="text-align: right;padding-right: 20px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_amount_yearly'"></span>
                    <span v-else v-t="'message.item_amount_monthly'"></span>
                </td>
            <tr>
            <tr v-for="(license , index) in licenseInfo.usageLicense" :class="{'license-record-no-hover': (index<licenseInfo.usageLicense.length-1),'license-record-no-hover-bottom': (index==licenseInfo.usageLicense.length-1)}">
                <td class="license-item-value">
                    {{ license.displayName}}
                </td>
                <td colspan="2" class="license-item-value" style="text-align: right">
                    {{ license.orgValue/license.unit }}({{ license.orgValue.toLocaleString() + getUnitName(license.type) }})
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 10px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(license.currentAmount) }}</span>
                    <span v-else>{{ getDisplayAmountValue(license.currentAmount) }}</span>
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 20px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(license.newAmount) }}</span>
                    <span v-else>-</span>
                </td>
            </tr>
            <!--- hr v-if="licenseInfo.chargedLicense.length > 0" class="transparent-hr">
            <tr v-if="licenseInfo.chargedLicense.length > 0" class="license-record-header">
                <td class="license-item-title" v-t="'message.item_license_charge'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.item_license_purchased_count2'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_amount_monthly'"></span>
                    <span v-else v-t="'message.item_amount_yearly'"></span>
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:20px">
                    <span v-if="purchasePeriodType == 0" v-t="'message.item_amount_yearly'"></span>
                    <span v-else v-t="'message.item_amount_monthly'"></span>
                </td>
            <tr>
            <tr v-for="(license , index) in licenseInfo.chargedLicense" :class="{'license-record-no-hover': (index<licenseInfo.chargedLicense.length-1),'license-record-no-hover-bottom': (index==licenseInfo.chargedLicense.length-1)}">
                <td class="license-item-value">
                    {{ license.displayName}}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ license.quantity }}({{ (license.quantity * license.unit).toLocaleString() + getUnitName(license.type) }})
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 10px">
                    <span v-if="purchasePeriodType == 0">{{ getDisplayAmountValue(license.currentAmount) }}</span>
                    <span v-else>-</span>
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 20px">
                    <span v-if="purchasePeriodType == 0">-</span>
                    <span v-else>{{ getDisplayAmountValue(license.newAmount) }}</span>
                </td>
            </tr---->
        </table>
    </div>
</template>

<script>
import commonUtil from './commonutil.js';

export default {
    data() {
        return {
        };
    },
    methods: {
        getUnitName(licenseType) {
            return commonUtil.getUnitName(this.$i18n, licenseType);
        },
        getDisplayAmountValue(amount) {
            if (this.currencyYen) {
                return Number(amount).toLocaleString();
            } else {
                return Number(amount).toFixed(2).toLocaleString();
            }
        },
    },
    components: {
    },
    created: function() {
    },
    props: [ 'licenseInfo' , 'purchasePeriodType' , 'confirmType' , 'currencyYen' , 'disablePurchasingOption' ]
}
</script scoped>
<style scoped>

.dialog-description {
    padding: 20px;
}
.dialog-body {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    max-height: calc(80vh - 290px);
    overflow: auto;
}

.license-item-value >>> .el-input-number {
    width: 160px;
}

.item >>> .el-popper[x-placement^=top] .popper__arrow:after {
    border-top-color: #fff;
}

</style scoped>
